module.exports = "pegasus/assets/themelp1/charity/107.png";